export enum AssetManagement {
  PHOTO = 'photo',
  ZILLOW3D = 'url'
}

// Single source of truth for the asset shape lives in carousel.types.ts;
// this re-export keeps the legacy import path working while the slice and
// hook converge on the unified type.
export type { ImageAssetType } from '@/components/ui/carousel/carousel.types';
